import type { User } from '@/types/auth';
import { hasPermission, Permission } from './permissions';

export const hasExceptionalPenaltyAccess = (
  user: User | null | undefined,
): boolean => hasPermission(user, Permission.PENALTIES_MANAGE);
